var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowManyYearsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89429 98.2342V75.2978C9.89429 52.7546 28.1685 34.4805 50.7117 34.4805C64.8021 34.4805 77.2235 41.6203 84.5599 52.4765",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7114 30.123C42.7037 30.123 36.1499 23.5692 36.1499 15.5615C36.1499 7.55378 42.7037 1 50.7114 1C58.7191 1 65.2729 7.55378 65.2729 15.5615C65.2729 23.5729 58.7191 30.123 50.7114 30.123Z",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1671 41.5289C58.5152 44.2698 54.8025 45.9834 50.7115 45.9834C44.7066 45.9834 39.5178 42.2967 37.2998 37.0781",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1843 31.4199V33.5229",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8435 34.4121H22.0891",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4016 34.4121H18.6472",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1843 35.4316V37.5346",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2886 12.5059V14.6089",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.948 15.498H77.1899",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5061 15.498H73.7517",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2886 16.5195V18.6225",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4961 82.1934V84.2964",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.155 85.1855H100.401",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.717 85.1855H96.9626",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4961 86.207V88.31",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53687 78.1816V80.2846",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19624 81.1738H4.44189",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75435 81.1738H1",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53687 82.1953V84.2983",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2364 72.0484C94.2364 72.5343 94.2364 73.0201 94.2364 73.5023C94.203 73.5728 94.1548 73.6395 94.1437 73.7137C93.5799 76.6401 91.1023 78.7765 88.213 78.8284C85.1902 78.8803 82.6199 76.8701 81.9485 73.9288C81.9189 73.8027 81.8892 73.6729 81.8336 73.4207C81.0843 76.5808 79.2632 78.5614 76.1254 78.7728C72.4832 79.0176 70.3209 77.0036 69.3973 73.5171C68.4144 76.8144 66.827 78.4946 63.8932 78.7542C60.1545 79.0843 57.944 77.0703 56.9648 73.48C56.8943 73.7805 56.8498 73.9993 56.7942 74.2181C55.9968 77.3114 52.9628 79.2401 49.6878 78.7357C46.7317 78.2795 44.4099 75.4384 44.6028 72.4119C44.7103 70.6909 44.9366 68.9736 45.1109 67.2564C45.3557 64.8307 45.6042 62.405 45.849 59.9793C45.9714 58.7776 46.0975 57.5759 46.2236 56.3594C61.6938 56.3594 77.1194 56.3594 92.5785 56.3594C92.6119 56.593 92.6527 56.8119 92.6749 57.0307C92.8159 58.4587 92.9531 59.8903 93.0977 61.322C93.3796 64.1186 93.6615 66.9114 93.9508 69.7043C94.0287 70.4869 94.14 71.2658 94.2364 72.0484Z",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2364 72.0484C94.2364 72.5343 94.2364 73.0201 94.2364 73.5023C94.203 73.5728 94.1548 73.6395 94.1437 73.7137C93.5799 76.6401 91.1023 78.7765 88.213 78.8284C85.1902 78.8803 82.6199 76.8701 81.9485 73.9288C81.9189 73.8027 81.8892 73.6729 81.8335 73.4207C81.0843 76.5808 79.2632 78.5614 76.1254 78.7728C72.4832 79.0176 70.3209 77.0036 69.3973 73.5171C68.4144 76.8144 66.827 78.4946 63.8932 78.7542C60.1545 79.0843 57.944 77.0703 56.9648 73.48C56.8943 73.7805 56.8498 73.9993 56.7942 74.2181C55.9968 77.3114 52.9628 79.2401 49.6878 78.7357C46.7317 78.2795 44.4099 75.4384 44.6028 72.4119C44.7103 70.6909 44.9366 68.9736 45.1109 67.2564C45.3557 64.8307 45.6042 62.405 45.849 59.9793C45.9714 58.7776 46.0975 57.5759 46.2236 56.3594C61.6938 56.3594 77.1194 56.3594 92.5785 56.3594C92.6119 56.593 92.6527 56.8119 92.6749 57.0307C92.8158 58.4587 92.9531 59.8903 93.0977 61.322C93.3796 64.1186 93.6615 66.9114 93.9508 69.7043C94.0287 70.4869 94.14 71.2658 94.2364 72.0484Z",
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4894 106.003C82.8572 106.003 73.2212 106.003 63.589 106.003C63.5927 99.7647 63.5964 93.5299 63.5964 87.2914C63.5964 87.2023 63.5705 87.1096 63.5593 87.028C59.9505 87.028 56.375 87.028 52.7514 87.028C52.7514 87.2506 52.7514 87.4434 52.7514 87.6326C52.7514 93.5447 52.7514 99.4605 52.7514 105.373C52.7514 105.58 52.7365 105.792 52.7291 105.999C50.5964 105.999 48.4601 105.999 46.3274 105.999C46.3274 97.6691 46.3274 89.3387 46.3274 80.9861C51.1231 82.6551 52.8107 82.4585 56.9981 79.7695C60.6218 82.8517 65.8886 82.7738 69.3936 79.7844C73.5588 82.8517 77.7128 82.8406 81.8521 79.7769C85.1456 82.3584 88.684 82.733 92.4931 80.975C92.4894 89.3535 92.4894 97.6765 92.4894 106.003ZM70.5693 98.0697C75.7322 98.0697 80.8766 98.0697 86.0284 98.0697C86.0284 94.3644 86.0284 90.6925 86.0284 87.0243C80.8543 87.0243 75.7248 87.0243 70.5693 87.0243C70.5693 90.7147 70.5693 94.3755 70.5693 98.0697Z",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.57 105.998H6.19629",
    stroke: "#005555",
    strokeWidth: 1.0664,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 57.5,
    r: 9.965,
    fill: "white",
    stroke: "#005555",
    strokeWidth: 1.07
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53V61L95.5 59",
    stroke: "#005555",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowManyYearsLogo);
export default __webpack_public_path__ + "static/media/howManyYearsLogo.d292a7aa32e38ef5f6a0de7c1903d4fa.svg";
export { ForwardRef as ReactComponent };